import { v4 as uuidv4 } from 'uuid';

export function SellerTable(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerTable',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				limitShownShippingInformation: 3,
			},
			props,
		),
		childrenComponents,
	};
}
